import React, { useEffect, useState } from 'react';
import { /* useDispatch, */ useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { Formik, FormikValues } from 'formik';
/* import { isEmpty } from 'lodash'; */
import { /* MyThunkDispatch, */ RootState } from 'store';
import * as yup from 'yup';

import Header from 'components/AppBar';
import SubmitButton from 'components/Buttons/SubmitButton';
import FormikSubmitErrorEffect from 'components/FormikSubmitErrorEffect';
import Input from 'components/Input';
import Loader from 'components/Loader';
import { Desktop, Mobile } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import Section from 'components/Section';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import { useParams } from 'react-router-dom';

import { Container, Content, Wrapper, FormContainer, Field, ButtonContainer } from './styles';
import { saveBreakRulesReason, updateBreakRulesReason } from 'services/resellerTravel';
import { DataTravelReason, TravelForm } from 'models/travelReseller';

interface Props {
  isLoading: boolean;
  breakRulesReasonSelected: DataTravelReason;
}
const BreakRulesForm = ({ isLoading, breakRulesReasonSelected }: Props) => {
  const toast = useToast();
  const history = useHistory();
  const { t } = useStoreTranslation();
  /* const dispatch: MyThunkDispatch = useDispatch(); */
  const [loading, setLoading] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const { breakRulesId } = useParams<{ breakRulesId?: string }>();
  const { company } = useSelector((state: RootState) => state.companyBilling);
  const location = useLocation<{ breakRulesData: { isAddButton: boolean } }>();
  const breakRulesData = location.state?.breakRulesData;

  const validationSchema = yup.object().shape({
    spanish: yup.string().trim().required(),
    portuguese: yup.string().trim().required(),
    english: yup.string().trim().required(),
  });

  const spanish = breakRulesReasonSelected?.name.find(item => item.language === 'ES')?.value || '' ;
  const portuguese = breakRulesReasonSelected?.name.find(item => item.language === 'PT')?.value || '';
  const english = breakRulesReasonSelected?.name.find(item => item.language === 'EN')?.value || '';

  const initValues = {
    spanish: spanish,
    portuguese: portuguese,
    english: english,
  };
  const handleSubmit = async (values: TravelForm) => {
    setLoading(true);
    const updatedReason = values;
    updatedReason.id = breakRulesId;
    updatedReason.companyId = company.id;
    (breakRulesData ? saveBreakRulesReason(updatedReason) : updateBreakRulesReason(updatedReason))
    .then((result) => {
      setLoading(false);
      toast.add({
        type: 'success',
        message: breakRulesData ? t('resellerForm.post.success') : t('resellerForm.put.success'),
      });
      history.replace('/corporate/BreakRulesReasons');
    })
    .catch((error) => {
      console.error('Error:', error);
      toast.add({
        type: 'danger',
        message: error.message,
      });
      setLoading(false);
    });
  };

  useEffect(() => {
    setIsEdit(breakRulesData?.isAddButton || false);
  }, [breakRulesReasonSelected]);

  const handleBack = () => {
    history.replace('/corporate/BreakRulesReasons');
  };

  return (
    <Wrapper className="target">
      {isLoading ? (
        <Loader fullScreen />
      ) : (
        <Container>
          <Desktop>
            <ScreenHeader title={t('breakRulesReason.title')} />
          </Desktop>
          <Mobile>
            <Header goBack={handleBack}>{t('breakRulesReason.title')}</Header>
          </Mobile>

          <Content>
            <Formik
              initialStatus={{ rightCheckIfIsValid: true }}
              initialValues={initValues}
              validationSchema={validationSchema}
              onSubmit={(value) => handleSubmit(value as TravelForm)}
              isInitialValid={(formik: FormikValues) => validationSchema.isValidSync(formik.initialValues)}
            >
              {({ dirty, isSubmitting }: FormikValues) => (
                <>
                  <FormikSubmitErrorEffect />

                  <FormContainer>
                    <Section title={t('breakRulesReason.title')} joinContent>
                      <Field name="spanish" label={t('resellerForm.spanish')}>
                        <Input id="spanish" placeholder={t('resellerForm.placeHolder')} />
                      </Field>
                      <Field name="portuguese" label={t('resellerForm.portuguese')}>
                        <Input id="portuguese" placeholder={t('resellerForm.placeHolder')} />
                      </Field>
                      <Field name="english" label={t('resellerForm.english')}>
                        <Input id="english" placeholder={t('resellerForm.placeHolder')} />
                      </Field>
                    </Section>
                    <ButtonContainer>
                      <SubmitButton isEdit={isEdit} dirty={dirty} loading={loading || isSubmitting}>
                        {isEdit ? t('breakRulesReason.saveButton') : t('breakRulesReason.editButton')}
                      </SubmitButton>
                    </ButtonContainer>
                  </FormContainer>
                </>
              )}
            </Formik>
          </Content>
        </Container>
      )}
    </Wrapper>
  );
};

export default BreakRulesForm;